export default __webpack_public_path__ + "static/1-37b5981497f741eecd91ec85a2030ba3.jpeg";